var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 96.1908C75.5105 96.1908 96.1908 75.5105 96.1908 50C96.1908 24.4895 75.5105 3.8092 50 3.8092C24.4895 3.8092 3.8092 24.4895 3.8092 50C3.8092 75.5105 24.4895 96.1908 50 96.1908ZM50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#88C62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2871 37.1174L38.0081 23.3688C38.2131 23.0611 38.4185 22.8557 38.7774 22.7018C39.5468 22.394 40.3677 22.7018 40.7782 23.3173L49.4992 37.1171C50.2685 38.3485 49.1914 39.8872 47.755 39.5283L42.9843 38.3997V52.1482C46.9857 48.3007 52.4236 45.9407 58.3744 45.8383L57.2458 41.016C56.9381 39.6308 58.4771 38.5022 59.657 39.2719L73.4055 47.9929C73.7133 48.1979 73.9187 48.4033 74.0725 48.7622C74.3803 49.5316 74.0725 50.3525 73.457 50.763L59.6572 59.484C58.4259 60.2533 56.8871 59.1762 57.2461 57.7398L58.3747 52.9691C49.8587 53.1741 42.9845 60.2025 42.9845 68.7697V70.2061C42.9845 70.8216 42.5229 71.2836 41.907 71.2836H36.9308C36.3153 71.2836 35.8533 70.8219 35.8533 70.2061V38.3997L31.0826 39.5283C29.5954 39.8872 28.5179 38.3485 29.2872 37.1172L29.2871 37.1174Z",
    fill: "#88C62C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/Directions.7ba65446b098bebbc3846db012ff627a.svg";
export { ForwardRef as ReactComponent };